import { Component, Input, Output, OnInit, OnChanges, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { CfCoreComponent } from '../core/core.component';
import { Transfer } from './ng2-file-uploader/source/transfer.core';
import { FileUploader } from './ng2-file-uploader/source/fileUploader.core';
import { FileManager } from './ng2-file-uploader/source/fileManager.core';
import { FileFilter } from './ng2-file-uploader/source/fileFilter.core';
import { FileSizePipe } from './ng2-file-uploader/pipe/fileSizePipe.pipe';
import { FileUploaderModel } from '../../models/file-uploader/file-uploader.model';
import { FileUploaderStylingModel } from '../../models/file-uploader/file-uploader-styling.model';
import { FileUploaderTemplates } from '../../templates/file-uploader.template';
import { ButtonModel } from '../../models/button/button.model';
import { TemplateService } from '../../services/template-service/template.service';
import * as _ from 'lodash';
/**
 * @hidden
 */
let { FileReader } = (<any>window);
/**
 * <p>CF File-uploader component</p>
 * <pre><code>
 * import {{'{'}} FileUploaderModel {{'}'}} from 'cedrus-fusion'
 * import {{'{'}} FileUploaderStylingModel {{'}'}} from 'cedrus-fusion'
 * <code><</code>cf-file-uploader<code>></code><code><</code><code>/</code>cf-file-uploader<code>></code>
 * </code></pre>
 */
export class CfFileUploaderComponent extends CfCoreComponent implements OnInit, OnChanges {
/**
 * @hidden 
 * It is a trigger for input[type="file"] which is opening browser window for selecting files
 */
loadWindowTrigger;
/**
 * <pre>{{'{'}}
 *  main: {{'{'}}
 *    url: string,                  // Path to server where the files be uploaded. Default: ''.
 *    alias: string,                // File alias. Default: file.
 *    headers: Object,              // An object with header informations. Default: {{'{'}}{{'}'}}.
 *    filters: FileFilter[],        // A list of filters which are extend the default list. Default: [].
 *    formData: Object[],           // A list of data to be sent along with the files. Default: [].
 *    autoUpload: boolean,          // Automatically upload new files when they are adding to the queue. Default: false.
 *    method: string,               // Request methode - HTML5 only. Default: POST.
 *    removeBySuccess: boolean,     // Remove file from queue when upload was successfull. Default: false.
 *    queueLimit: number,           // Limitation of files at the queue (-1 is unlimited). Default: -1.
 *    enableCors: boolean,          // Activate CORS - HTML5 only. Default: false.
 *    withCredentials: boolean,     // If to use credentials. Default: false.
 *    uniqueFiles: boolean,         // To add only unique files to files list. Default: false.
 *  {{'}'}},
 *  showDropZone: boolean,          // Means if component must show dropZone. Default: true.
 *  readFiles: boolean,             // Means if read files content after file was added to the list. Default: false.
 *  filesNames: string[],           // Means part or all text of file name to match. Default: [].
 *  filesTypes: string[],           // Means what file types are resolved to add. Default: [].
 *  filesSizes: string[],           // Means what files by size are resolved to add. Default: [].
 *  filesDates: string[],           // Means what files by date are resolved to add. Default: [].
 *  dropZoneLabel: string,          // Means label for dropZone. Default: Drop files here or click to select: .
 *  showFilesActions: boolean,      // Means if to show actions for all selected files. Default: true.
 *  showFileActions: boolean,       // Means if to show actions for a single file. Default: true.
 *  uploadFileButton: ButtonModel,  // ButtonModel for each file uploa. Default: new ButtonModel({{'{'}} label: "Upload" {{'}'}}).
 *  removeFileButton: ButtonModel,  // ButtonModel for each file remov. Default: new ButtonModel({{'{'}} label: "Remove" {{'}'}}).
 *  uploadFilesButton: ButtonModel, // ButtonModel for upload all file. Default: new ButtonModel({{'{'}} label: "Upload All" {{'}'}}).
 *  removeFilesButton: ButtonModel, // ButtonModel for remove all file. Default: new ButtonModel({{'{'}} label: "Remove All" {{'}'}}).
 * {{'}'}}</pre>
 * <p>Example of object:</p>
 * <pre>{{'{'}}
 *  main: {{'{'}}
 *    "url": "http://localhost:3001/upload",
 *    "removeBySuccess": true,
 *  {{'}'}},
 *  "readFiles": true,
 *  "filesNames": ['json', 'png'],
 * {{'}'}}</pre>
 */
properties: FileUploaderModel;
/**
 * <pre>{{'{'}}
 *  dropZone: StylingModel,                // Styling dropZone html element
 *  files: StylingModel,                   // Styling files html element
 *  file: StylingModel,                    // Styling file html element
 *  fileImage: StylingModel,               // Styling fileImage html element
 *  fileName: StylingModel,                // Styling fileName html element
 *  fileProgress: StylingModel,            // Styling fileProgress html element
 *  fileActions: StylingModel,             // Styling fileActions html element
 *  filesActions: StylingModel,            // Styling filesActions html element
 *  uploadFileButton: ButtonStylingModel,  // Styling uploadFileButton html element
 *  removeFileButton: ButtonStylingModel,  // Styling removeFileButton html element
 *  uploadFilesButton: ButtonStylingModel, // Styling uploadFilesButton html element
 *  removeFilesButton: ButtonStylingModel, // Styling removeFilesButton html element
 * {{'}'}}</pre>
 * <p>Example of object:</p>
 * <pre>{{'{'}}
 *  myUploaderStyling = new FileUploaderStylingModel({{'{'}}
 *    dropZone: {{'{'}}
 *      class: 'dropzone-styling'
 *    {{'}'}},
 *    uploadButton: new ButtonStylingModel({{'{'}}
 *      button: {{'{'}} class: 'mat-primary mat-raised-button' {{'}'}}
 *    {{'}'}}),
 *    removeButton: new ButtonStylingModel({{'{'}}
 *      button: {{'{'}} class: 'mat-primary mat-raised-button' {{'}'}}
 *    {{'}'}}),
 *    uploadAllButton: new ButtonStylingModel({{'{'}}
 *      button: {{'{'}} class: 'mat-primary mat-raised-button' {{'}'}}
 *    {{'}'}}),
 *    removeAllButton: new ButtonStylingModel({{'{'}}
 *      button: {{'{'}} class: 'mat-primary mat-raised-button' {{'}'}}
 *    {{'}'}})
 *  {{'}'}});
 * {{'}'}}</pre>
 */
styling: FileUploaderStylingModel;
/**
 * Object with Transfer type properties for uploader engine
 * @param {?} value
 * @return {?}
 */
set main(value: Transfer) { this.properties.main = value; }
/**
 * Means if read files content after file was added to the list
 * @param {?} value
 * @return {?}
 */
set readFiles(value: boolean) { this.properties.readFiles = value; }
/**
 * Means part or all text of file name to match
 * @param {?} value
 * @return {?}
 */
set filesNames(value: string[]) { this.properties.filesNames = value; }
/**
 * Means what file types are resolved to add
 * @param {?} value
 * @return {?}
 */
set filesTypes(value: string[]) { this.properties.filesTypes = value; }
/**
 * Means what files by size are resolved to add
 * @param {?} value
 * @return {?}
 */
set filesSizes(value: string[]) { this.properties.filesSizes = value; }
/**
 * Means what files by date are resolved to add
 * @param {?} value
 * @return {?}
 */
set filesDates(value: string[]) { this.properties.filesDates = value; }
/**
 * Means if component must show dropZone.
 * @param {?} value
 * @return {?}
 */
set showDropZone(value: boolean) { this.properties.showDropZone = value; }
/**
 * Means label for dropZone.
 * @param {?} value
 * @return {?}
 */
set dropZoneLabel(value: string) { this.properties.dropZoneLabel = value; }
/**
 * Means if to show actions for all selected files.
 * @param {?} value
 * @return {?}
 */
set showFilesActions(value: boolean) { this.properties.showFilesActions = value; }
/**
 * Means if to show actions for a single file.
 * @param {?} value
 * @return {?}
 */
set showFileActions(value: boolean) { this.properties.showFileActions = value; }
/**
 * ButtonModel for each file upload
 * @param {?} value
 * @return {?}
 */
set uploadFileButton(value: ButtonModel) { this.properties.uploadFileButton = value; }
/**
 * ButtonModel for each file remove
 * @param {?} value
 * @return {?}
 */
set removeFileButton(value: ButtonModel) { this.properties.removeFileButton = value; }
/**
 * ButtonModel for upload all files
 * @param {?} value
 * @return {?}
 */
set uploadFilesButton(value: ButtonModel) { this.properties.uploadFilesButton = value; }
/**
 * ButtonModel for remove all files
 * @param {?} value
 * @return {?}
 */
set removeFilesButton(value: ButtonModel) { this.properties.removeFilesButton = value; }
/**
 * Event emited when file was added to list. Event contain added file
 */
onAddFile: EventEmitter<any> = new EventEmitter<any>();
/**
 * Event emited when all files was added to list. Event contain whole component
 */
onAddFiles: EventEmitter<any> = new EventEmitter<any>();
/**
 * Event emited on error adding file to list. Event contain error file
 */
onAddFileError: EventEmitter<any> = new EventEmitter<any>();
/**
 * Event emited when file was uploaded. Event contain uploaded file
 */
onComplete: EventEmitter<any> = new EventEmitter<any>();
/**
 * Event emited when all files was uploaded. Event contain whole component
 */
onCompleteAll: EventEmitter<any> = new EventEmitter<any>();
/**
 * @hidden
 */
_reader;
/**
 * @hidden
 */
acceptedFiles = '';
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
public constructor(public elementRef: ElementRef, /**@hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
    this.properties = new FileUploaderModel();
    this.styling = new FileUploaderStylingModel();
  }
/**
 * @hidden 
 * On init it is generating FileUploaderModel and based on it -
 * generating FileUploader model for external library.
 * Also are registered event emiters for external library events. And generated styling object.
 * @return {?}
 */
ngOnInit() {
    this._reader = new FileReader();
    this.getMyTemplate('file-uploader', FileUploaderTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'FILE-UPLOADER').then( sampler => {
        this.properties.main = _.cloneDeep( new FileUploader(this.properties.main) );
        this.properties.main.onAddFile = (_file: FileManager): void => {
          if (this.properties.readFiles) {
            let /** @type {?} */ that = this;
            let /** @type {?} */ _reader = new FileReader();
            let /** @type {?} */ _fileContent;
            _reader.onloadend = function (evt) {
              if (evt.target.readyState === FileReader.DONE) {
                _fileContent = evt.target.result;
                that.onAddFile.emit({ file: _file, fileContent: _fileContent });
              }
            };
            if (_file.type.match('image.*')) {
              _reader.readAsDataURL(_file.element);
              // } else if(_file.type.match('pdf')) {
              //   console.log('pdf');
              //   _reader.readAsArrayBuffer(_file.element);
            } else {
              let /** @type {?} */ blob = _file.element.slice(0, _file.size);
              _reader.readAsBinaryString(blob);
            }
          } else {
            this.onAddFile.emit({ file: _file });
          }
        }
        this.properties.main.onAddFileAll = (_uploader: Transfer): void => {
          this.onAddFiles.emit(_uploader);
        }
        this.properties.main.onAddFileError = (_file: FileManager): void => {
          this.onAddFileError.emit(_file);
        }
        this.properties.main.onComplete = (_file: FileManager, _response: any, _status: number, _headers: any): void => {
          this.onComplete.emit({ file: _file, response: _response, status: _status, headers: _headers });
        }
        this.properties.main.onCompleteAll = (_uploader: Transfer): void => {
          this.onCompleteAll.emit(_uploader);
        }
        this.checkForFilters();
        // console.log('FILE-UPLOADER', this);
      });
    });
  }
/**
 * @hidden 
 * Update the properties object with the changes on the inputs to keep the component dynamic
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: any) {
    if (this.properties != null) {
      if (changes.filesNames != null || changes.filesTypes != null || changes.filesSizes != null || changes.filesDates != null) {
        this.checkForFilters();
      }
    }
  }
/**
 * @hidden 
 * It is function for trigger opening browser window
 * @return {?}
 */
openWindow() {
    this.loadWindowTrigger.nativeElement.click();
  }
/**
 * @hidden 
 * It is function for clearing list with added files
 * @return {?}
 */
removeAll() {
    this.properties.main.queueObs.forEach(() => {
      setTimeout(() => {
        this.properties.main.remove();
      }, 0);
    })
  }
/**
 * @hidden 
 * Function to calculate uploading percentage process
 * @param {?} process  it is json process object
 * @return {?}
 */
processingFile(process: any) { return process.percent; }
/**
 * @hidden 
 * Function to calculate file size
 * @param {?} process  it is json process object
 * @return {?}
 */
processedFile(process: any) { return process.loaded; }
/**
 * @hidden 
 * Function to check if file is image
 * @param {?} type
 * @return {?}
 */
isImage(type) { return type.match('image.*'); }
/**
 * @hidden 
 * Function to generate filters
 * @param {?} type  it is type of filter
 * @param {?} filters  it is array with filtering values
 * @return {?}
 */
generateFilters(type, filters) {
    let /** @type {?} */ _regExp = '', /** @type {?} */
      _accepts = '', /** @type {?} */
      _ftl = filters.length;
    for (let /** @type {?} */ i = 0; i < _ftl; ++i) {
      _regExp = _regExp + filters[i];
      if (type === 'name' || type === 'type') { _accepts = _accepts + filters[i]; }
      if (i < _ftl - 1) {
        _regExp = _regExp + '|';
        if (type === 'name' || type === 'type') { _accepts = _accepts + ','; }
      }
    }
    this.properties.main.options.filters.push(new FileFilter(_regExp, new RegExp(_regExp), type));
    if (type === 'name' || type === 'type') { this.acceptedFiles = _accepts; }
  }
/**
 * @hidden 
 * Function to check if there any filters
 * @return {?}
 */
checkForFilters() {
    if (this.properties.filesNames && this.properties.filesNames.length > 0) {
      this.generateFilters('name', this.properties.filesNames);
    }
    if (this.properties.filesTypes && this.properties.filesTypes.length > 0) {
      this.generateFilters('type', this.properties.filesTypes);
    }
    if (this.properties.filesSizes && this.properties.filesSizes.length > 0) {
      this.generateFilters('size', this.properties.filesSizes);
    }
    if (this.properties.filesDates && this.properties.filesDates.length > 0) {
      this.generateFilters('date', this.properties.filesDates);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-file-uploader',
  template: "<div *ngIf=\"_inited && properties?.display\" class=\"{{activeTemplate.style?.container?.class}} {{styling?.container?.class}} {{getDynamicClasses(activeTemplate.style?.container?.dynamicClass)}} {{getDynamicClasses(styling?.container?.dynamicClass)}}\" [ngClass]=\"'cf-file-uploader-container'\"> <input #loadWindowTrigger style=\"display: none !important\" type=\"file\" ng2File2Select [uploader]=\"properties?.main\" multiple accept=\"{{acceptedFiles}}\" /> <div *ngIf=\"properties?.showDropZone\" class=\"{{activeTemplate.style?.dropZone?.class}} {{styling?.dropZone?.class}} {{getDynamicClasses(activeTemplate.style?.dropZone?.dynamicClass)}} {{getDynamicClasses(styling?.dropZone?.dynamicClass)}}\" [ngClass]=\"'cf-file-uploader-drop-zone'\"> <p class=\"cf-file-uploader-drop-zone-label\" [innerHtml]=\"properties?.dropZoneLabel\"></p> <file-drop [accepts]=\"acceptedFiles\" [uploader]=\"properties?.main\"></file-drop> </div> <div *ngIf=\"properties?.main?.queueObs?.length > 0\" class=\"cf-file-uploader-files {{styling?.files?.class}}\" [ngClass]=\"getDynamicClasses(styling?.files?.dynamicClass)\"> <div *ngFor=\"let file of (properties?.main?.queue$ | async)\" class=\"{{activeTemplate.style?.file?.class}} {{styling?.file?.class}} {{getDynamicClasses(activeTemplate.style?.file?.dynamicClass)}} {{getDynamicClasses(styling?.file?.dynamicClass)}}\" [ngClass]=\"'cf-file-uploader-file'\"> <div class=\"cf-file-uploader-file-data\"> <div *ngIf=\"isImage(file.type)\" class=\"{{activeTemplate.style?.fileImage?.class}} {{styling?.fileImage?.class}} {{getDynamicClasses(activeTemplate.style?.fileImage?.dynamicClass)}} {{getDynamicClasses(styling?.fileImage?.dynamicClass)}}\" [ngClass]=\"'cf-file-uploader-file-image'\"> <picture [class.success]=\"file?.success\"><img src=\"\" imgPreview [image]=\"file\" /></picture> </div> <div class=\"cf-file-uploader-file-options\"> <div class=\"cf-file-uploader-file-info\"> <div class=\"{{activeTemplate.style?.fileName?.class}} {{styling?.fileName?.class}} {{getDynamicClasses(activeTemplate.style?.fileName?.dynamicClass)}} {{getDynamicClasses(styling?.fileName?.dynamicClass)}}\" [ngClass]=\"'cf-file-uploader-file-name'\">{{file?.name}}</div> <div *ngIf=\"properties?.main.options.url !==''\" class=\"cf-file-uploader-file-size\">{{processedFile(file?.progress$ | async) | fileSize }} uploaded</div> </div> <div *ngIf=\"properties?.showFileActions\" class=\"{{activeTemplate.style?.fileActions?.class}} {{styling?.fileActions?.class}} {{getDynamicClasses(activeTemplate.style?.fileActions?.dynamicClass)}} {{getDynamicClasses(styling?.fileActions?.dynamicClass)}}\" [ngClass]=\"'cf-file-uploader-file-actions'\"> <cf-button [properties]=\"properties?.uploadFileButton\" [styling]=\"styling?.uploadFileButton\" (click)=\"file?.upload()\" *ngIf=\"properties?.main.options.url !==''\"></cf-button> <cf-button [properties]=\"properties?.removeFileButton\" [styling]=\"styling?.removeFileButton\" (click)=\"file?.remove()\"></cf-button> </div> </div> </div> <div *ngIf=\"properties?.main.options.url !==''\" class=\"{{activeTemplate.style?.fileProgress?.class}} {{styling?.fileProgress?.class}} {{getDynamicClasses(activeTemplate.style?.fileProgress?.dynamicClass)}} {{getDynamicClasses(styling?.fileProgress?.dynamicClass)}}\" [ngClass]=\"'cf-file-uploader-file-progress'\"> <md-progress-bar class=\"cf-file\" [color]=\"'primary'\" [mode]=\"'determinate'\" [value]=\"processingFile(file?.progress$ | async)\"></md-progress-bar> </div> </div> <div class=\"{{activeTemplate.style?.fileActions?.class}} {{styling?.fileActions?.class}} {{getDynamicClasses(activeTemplate.style?.fileActions?.dynamicClass)}} {{getDynamicClasses(styling?.fileActions?.dynamicClass)}}\" [ngClass]=\"'cf-file-uploader-files-actions'\" *ngIf=\"properties?.showFilesActions\"> <cf-button [properties]=\"properties?.uploadFilesButton\" [styling]=\"styling?.uploadFilesButton\" (click)=\"properties?.main?.upload()\" *ngIf=\"properties?.main.options.url !==''\"></cf-button> <cf-button [properties]=\"properties?.removeFilesButton\" [styling]=\"styling?.removeFilesButton\" (click)=\"removeAll()\"></cf-button> </div> </div> </div>",
  styles: [".cf-file-uploader-drop-zone-label { font-family: 'Avenir', Helvetica, sans-serif; font-size: 12px; color: rgba(0, 0, 0, 0.38); } .cf-file-uploader-file { display: flex; flex-direction: column; align-items: center; margin: 4px 0; } .cf-file-uploader-file-data { display: flex; flex-direction: row; align-items: center; width: 100%; } .cf-file-uploader-file-image { width: 100px; text-align: center; } .cf-file-uploader-file-image img { max-width: 100px; max-height: 100px; } .cf-file-uploader-file-options { display: flex; flex-direction: row; flex-grow: 1; } .cf-file-uploader-file-info { display: flex; flex-direction: column; flex-grow: 1; } .cf-file-uploader-file-name, .cf-file-uploader-file-size { font-family: 'Avenir', Helvetica, sans-serif; font-size: 14px; padding: 4px 8px; } .cf-file-uploader-file-size { color: rgba(0, 0, 0, 0.38); font-size: 12px; } .cf-file-uploader-file-actions { display: flex; flex-direction: row; align-items: center; } .cf-file-uploader-file-actions cf-button { margin-left: 8px; } .cf-file-uploader-file-progress { width: 100%; } .cf-file-uploader-files-actions { display: flex; flex-direction: row; justify-content: flex-end; } .cf-file-uploader-files-actions cf-button { margin-left: 8px; } .cf-file-uploader-drop-zone ::ng-deep .drop-area { position: relative; z-index: 1; display: block; box-sizing: border-box; border: none; width: 100%; height: 120px; border-radius: 4px; cursor: pointer; transition: background-color cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s, border-color cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s, opacity cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s; background-color: rgba(0, 0, 0, 0.03); box-shadow: inset 0px 0px 8px 0px rgba(0, 0, 0, 0.2); background-clip: padding-box; } .cf-file-uploader-drop-zone ::ng-deep .drop-area.drop-enter { background-color: rgba(0, 0, 0, 0.1); border-color: rgba(0, 0, 0, 0.9); } .cf-file-uploader-drop-zone ::ng-deep .drop-area:after { content: '' !important; display: none !important; } .cf-file-uploader-drop-zone ::ng-deep .drop-area input { display: none !important; } .cf-file-uploader-drop-zone ::ng-deep .drop-area img, .cf-file-uploader-drop-zone ::ng-deep .drop-area .icon { pointer-events: none; } .cf-file-uploader-drop-zone ::ng-deep .drop-area img { left: 50%; opacity: 0; max-height: 90%; max-width: 90%; position: absolute; top: 50%; transition: all 300ms ease-in; transform: translate(-50%, -50%); z-index: -1; } .cf-file-uploader-drop-zone ::ng-deep .drop-area img.loaded { opacity: .7; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'loadWindowTrigger': [{ type: ViewChild, args: ['loadWindowTrigger', ] },],
'properties': [{ type: Input },],
'styling': [{ type: Input },],
'main': [{ type: Input, args: ['main', ] },],
'readFiles': [{ type: Input, args: ['readFiles', ] },],
'filesNames': [{ type: Input, args: ['filesNames', ] },],
'filesTypes': [{ type: Input, args: ['filesTypes', ] },],
'filesSizes': [{ type: Input, args: ['filesSizes', ] },],
'filesDates': [{ type: Input, args: ['filesDates', ] },],
'showDropZone': [{ type: Input, args: ['showDropZone', ] },],
'dropZoneLabel': [{ type: Input, args: ['dropZoneLabel', ] },],
'showFilesActions': [{ type: Input, args: ['showFilesActions', ] },],
'showFileActions': [{ type: Input, args: ['showFileActions', ] },],
'uploadFileButton': [{ type: Input, args: ['uploadFileButton', ] },],
'removeFileButton': [{ type: Input, args: ['removeFileButton', ] },],
'uploadFilesButton': [{ type: Input, args: ['uploadFilesButton', ] },],
'removeFilesButton': [{ type: Input, args: ['removeFilesButton', ] },],
'onAddFile': [{ type: Output },],
'onAddFiles': [{ type: Output },],
'onAddFileError': [{ type: Output },],
'onComplete': [{ type: Output },],
'onCompleteAll': [{ type: Output },],
};
}

function CfFileUploaderComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfFileUploaderComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfFileUploaderComponent.ctorParameters;
/** @type {?} */
CfFileUploaderComponent.propDecorators;
/**
 * @hidden 
 * It is a trigger for input[type="file"] which is opening browser window for selecting files
 * @type {?}
 */
CfFileUploaderComponent.prototype.loadWindowTrigger;
/**
 * <pre>{{'{'}}
 *  main: {{'{'}}
 *    url: string,                  // Path to server where the files be uploaded. Default: ''.
 *    alias: string,                // File alias. Default: file.
 *    headers: Object,              // An object with header informations. Default: {{'{'}}{{'}'}}.
 *    filters: FileFilter[],        // A list of filters which are extend the default list. Default: [].
 *    formData: Object[],           // A list of data to be sent along with the files. Default: [].
 *    autoUpload: boolean,          // Automatically upload new files when they are adding to the queue. Default: false.
 *    method: string,               // Request methode - HTML5 only. Default: POST.
 *    removeBySuccess: boolean,     // Remove file from queue when upload was successfull. Default: false.
 *    queueLimit: number,           // Limitation of files at the queue (-1 is unlimited). Default: -1.
 *    enableCors: boolean,          // Activate CORS - HTML5 only. Default: false.
 *    withCredentials: boolean,     // If to use credentials. Default: false.
 *    uniqueFiles: boolean,         // To add only unique files to files list. Default: false.
 *  {{'}'}},
 *  showDropZone: boolean,          // Means if component must show dropZone. Default: true.
 *  readFiles: boolean,             // Means if read files content after file was added to the list. Default: false.
 *  filesNames: string[],           // Means part or all text of file name to match. Default: [].
 *  filesTypes: string[],           // Means what file types are resolved to add. Default: [].
 *  filesSizes: string[],           // Means what files by size are resolved to add. Default: [].
 *  filesDates: string[],           // Means what files by date are resolved to add. Default: [].
 *  dropZoneLabel: string,          // Means label for dropZone. Default: Drop files here or click to select: .
 *  showFilesActions: boolean,      // Means if to show actions for all selected files. Default: true.
 *  showFileActions: boolean,       // Means if to show actions for a single file. Default: true.
 *  uploadFileButton: ButtonModel,  // ButtonModel for each file uploa. Default: new ButtonModel({{'{'}} label: "Upload" {{'}'}}).
 *  removeFileButton: ButtonModel,  // ButtonModel for each file remov. Default: new ButtonModel({{'{'}} label: "Remove" {{'}'}}).
 *  uploadFilesButton: ButtonModel, // ButtonModel for upload all file. Default: new ButtonModel({{'{'}} label: "Upload All" {{'}'}}).
 *  removeFilesButton: ButtonModel, // ButtonModel for remove all file. Default: new ButtonModel({{'{'}} label: "Remove All" {{'}'}}).
 * {{'}'}}</pre>
 * <p>Example of object:</p>
 * <pre>{{'{'}}
 *  main: {{'{'}}
 *    "url": "http://localhost:3001/upload",
 *    "removeBySuccess": true,
 *  {{'}'}},
 *  "readFiles": true,
 *  "filesNames": ['json', 'png'],
 * {{'}'}}</pre>
 * @type {?}
 */
CfFileUploaderComponent.prototype.properties;
/**
 * <pre>{{'{'}}
 *  dropZone: StylingModel,                // Styling dropZone html element
 *  files: StylingModel,                   // Styling files html element
 *  file: StylingModel,                    // Styling file html element
 *  fileImage: StylingModel,               // Styling fileImage html element
 *  fileName: StylingModel,                // Styling fileName html element
 *  fileProgress: StylingModel,            // Styling fileProgress html element
 *  fileActions: StylingModel,             // Styling fileActions html element
 *  filesActions: StylingModel,            // Styling filesActions html element
 *  uploadFileButton: ButtonStylingModel,  // Styling uploadFileButton html element
 *  removeFileButton: ButtonStylingModel,  // Styling removeFileButton html element
 *  uploadFilesButton: ButtonStylingModel, // Styling uploadFilesButton html element
 *  removeFilesButton: ButtonStylingModel, // Styling removeFilesButton html element
 * {{'}'}}</pre>
 * <p>Example of object:</p>
 * <pre>{{'{'}}
 *  myUploaderStyling = new FileUploaderStylingModel({{'{'}}
 *    dropZone: {{'{'}}
 *      class: 'dropzone-styling'
 *    {{'}'}},
 *    uploadButton: new ButtonStylingModel({{'{'}}
 *      button: {{'{'}} class: 'mat-primary mat-raised-button' {{'}'}}
 *    {{'}'}}),
 *    removeButton: new ButtonStylingModel({{'{'}}
 *      button: {{'{'}} class: 'mat-primary mat-raised-button' {{'}'}}
 *    {{'}'}}),
 *    uploadAllButton: new ButtonStylingModel({{'{'}}
 *      button: {{'{'}} class: 'mat-primary mat-raised-button' {{'}'}}
 *    {{'}'}}),
 *    removeAllButton: new ButtonStylingModel({{'{'}}
 *      button: {{'{'}} class: 'mat-primary mat-raised-button' {{'}'}}
 *    {{'}'}})
 *  {{'}'}});
 * {{'}'}}</pre>
 * @type {?}
 */
CfFileUploaderComponent.prototype.styling;
/**
 * Event emited when file was added to list. Event contain added file
 * @type {?}
 */
CfFileUploaderComponent.prototype.onAddFile;
/**
 * Event emited when all files was added to list. Event contain whole component
 * @type {?}
 */
CfFileUploaderComponent.prototype.onAddFiles;
/**
 * Event emited on error adding file to list. Event contain error file
 * @type {?}
 */
CfFileUploaderComponent.prototype.onAddFileError;
/**
 * Event emited when file was uploaded. Event contain uploaded file
 * @type {?}
 */
CfFileUploaderComponent.prototype.onComplete;
/**
 * Event emited when all files was uploaded. Event contain whole component
 * @type {?}
 */
CfFileUploaderComponent.prototype.onCompleteAll;
/**
 * @hidden
 * @type {?}
 */
CfFileUploaderComponent.prototype._reader;
/**
 * @hidden
 * @type {?}
 */
CfFileUploaderComponent.prototype.acceptedFiles;
/** @type {?} */
CfFileUploaderComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
